const GENERAL = {
	SELECT_FILE: "Selecionar arquivo",
	LOGOUT: "Saindo...",
	LOADING: "Carregando...",
	SAVING: "Salvando...",
	ARE_YOU_SURE: "Tem certeza que deseja sair?",
};

export default GENERAL;